import { ControlFacet } from '../models/controls/ControlFacet';
import { IAsyncActionCreator } from '../store/actions/createActionCreator';
import { IItemCacheThunkAction } from '../store/actions/ItemCacheActions';
import { IWizardActionStateProps } from '../components/wizardAction/WizardAction';

/**
 * @public
 */
export interface ISyncInfo {
  protocolUrl: string;
  syncConfigParams: string;
}

/**
 * @public
 */
export interface ISyncWizardProps extends IWizardActionStateProps {
  itemKey: string;
  clientDownloadUrl: string;
  userLoginName: string;
  protocolCallback?: (syncUrl: string) => void;
  isTenantAdmin(): Promise<boolean>;
  getSyncInfo(): Promise<ISyncInfo>;
}

/**
 * @public
 */
export const itemSyncControl: ControlFacet<{
  itemKey: string;
}, {
    isAvailable: boolean;
    userLoginName: string;
    clientDownloadUrl: string;
    isTenantAdmin: IAsyncActionCreator<{}, IItemCacheThunkAction<Promise<boolean>>>;
    getSyncInfo: IAsyncActionCreator<{}, IItemCacheThunkAction<Promise<ISyncInfo>>>;
    SyncWizard: React.ComponentType<ISyncWizardProps>;
    protocolCallback: (syncUrl: string) => void;
  }> = new ControlFacet('itemSyncControl');
